export default __webpack_public_path__ + "static/media/WIN.551038ba.png";